import { useEffect, useState } from "react";
import { connect } from 'react-redux';
import { useHistory } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";
import DropnGoDashboardCard from "../../admin/components/report/DropNGoDashboardCard";


const DropnGoDashboard = ({ token, staff }) => {

    const history = useHistory();

    const [toggled, setToggled] = useState(false)

    useEffect(() => {
        if (!staff || !staff.dropngo_dashboard) {
            history.push('/staff/dashboard')
        }
    }, [])

    const handleToggle = () => {
        setToggled(!toggled);
    }

    return (
        <div className="admin-page-container">
            <Sidebar toggled={toggled} setToggled={handleToggle} />
            <div className="admin-page">
                <Topbar handleToggle={handleToggle} />

                <div className="admin-content">
                    <DropnGoDashboardCard
                        token={token}
                    />
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = state => {
    return {
        staff: state.staff.staff,
        token: state.staff.token,
    };
};

export default connect(mapStateToProps, null)(DropnGoDashboard);